module.exports = __webpack_public_path__ + "static/media/grain_10.80946b97.jpg";